/** @format */

export const EXCEL_FORMATS = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

export const PPT_FORMATS = [
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const WORD_FORMATS = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const ATTACHMENT_FIELDS = [
  { key: "unitEconomics", label: "Unit Economics", accept: ".xlsx,.xls", fileFormats: EXCEL_FORMATS },
  { key: "siteRecommendationDeck", label: "Site Recommendation Deck", accept: ".ppt,.pptx", fileFormats: PPT_FORMATS, maxSize: 20 },
  { key: "addressExcelFile", label: "Address Excel File", accept: ".xlsx,.xls", fileFormats: EXCEL_FORMATS },
  { key: "addressWordFile", label: "Address Word File", accept: ".doc,.docx", fileFormats: WORD_FORMATS },
  { key: "layout", label: "Layout", accept: ".pdf", fileFormats: ["application/pdf"] },
  { key: "capexSheet", label: "Capex Sheet", accept: ".xlsx,.xls", fileFormats: EXCEL_FORMATS },
  { key: "geoiqReport", label: "GeoIQ Report", accept: ".pdf", fileFormats: ["application/pdf"], maxSize: 8 },
];

export const DATE_FORMATS = {
  "DD.MM.YYYY": "DD.MM.YYYY",
  "DD-MM-YYYY": "DD-MM-YYYY",
  "DD.MM.YYYY hh:MM": "DD.MM.YYYY hh:MM",
  "DD MMM YY hh:MM": "DD MMM YY hh:MM",
  "MMM DD YYYY hh:MM": "MMM DD YYYY hh:MM",
  "YYYY-MM-DD": "YYYY-MM-DD",
};

export const userTypes = {
  admin: "ADMIN",
  user: "USER",
};

export const storeTypes = {
  cocoBuild: "COCO BUILT",
  cocoAcquired: "COCO ACQUIRED",
};

export const userStates = {
  isProcessing: "Checking",
};

export const allStores = Object.values(storeTypes);

export const storeList = allStores.map((item) => {
  return { label: item, value: item };
});

export const cocoAcqKeyNames = {
  competitionAndNearbyRestaurantSales: "Monthly P&L - TTM Vs Forward 1 yr",
  ads: "ADS - Fwd Yr1",
  labourPercentage: "Fwd 1 Yr Labour(%)",
  occupancyPercentage: "Fwd 1 Yr Occupancy(%)",
  ebitdaPercentage: "Fwd 1 Yr EBITDA(%)",
  deliveryPercentage: "Fwd 1 Yr Delivery(%)",
  adsTtm: "ADS - TTM",
  ttmEbitdaPercentage: "TTM EBITDA %",
  forward1YearEbitdaMultiple: "Forward 1 yr EBITDA Multiple",
  grossOfferExtendedA: "Total Gross Offer (INR lacs)",
  ttmAdjustedEbitdaMultiple: "TTM Adjusted EBITDA multiple",
  totalCapex: "Total Acquistion Cost (INR lacs)",
  priceCohort: "Price Cohort",
  orderingPlatform: "Ordering Platform",
};

export const cocoBuiltKeyNames = {
  competitionAndNearbyRestaurantSales:
    "Competition and Nearby restaurant sales",
  ads: "ADS (Avg Daily Sales)",
  labourPercentage: "Labour(%)",
  occupancyPercentage: "Occupancy(%)",
  ebitdaPercentage: "EBITDA(%)",
  deliveryPercentage: "Delivery(%)",
  totalCapex: "Total Capex (INR lacs)",
  priceCohort: "Price Cohort",
  orderingPlatform: "Ordering Platform",
};

// Single source of truth for CF status / stage colors across the app (tables, details, etc.).
// Keyed by both the form-level status (OPENED, DROPPED) and the step lifecycle stage / cfStatus
// (LEAD, UNDER_DISCUSSION, APPROVED, UNDER_CONSTRUCTION). `text` is the on-color foreground.
export const CF_STATUS_COLORS = {
  LEAD: { bg: "#CC7722", text: "#fff" }, // Ochre
  UNDER_DISCUSSION: { bg: "#4FC3F7", text: "#0B3954" }, // Light Blue
  APPROVED: { bg: "#0D47A1", text: "#fff" }, // Dark Blue
  UNDER_CONSTRUCTION: { bg: "#8E24AA", text: "#fff" }, // Purple
  OPENED: { bg: "#008938", text: "#fff" }, // Subway Green
  DROPPED: { bg: "#9E9E9E", text: "#fff" }, // Grey
  EXCEPTION_PENDING: { bg: "#ED6C02", text: "#fff" }, // Amber
};

// Returns MUI `sx` for an outlined Chip (use with variant="outlined") tinted with
// the status/stage color. Falls back to grey for any unmapped value.
export const getCfStatusChipSx = (value) => {
  const c = CF_STATUS_COLORS[value] || { bg: "#9E9E9E", text: "#fff" };
  return { color: c.bg, borderColor: c.bg, fontWeight: 600 };
};

// Display-label overrides for CF status/stage values. Values not listed here
// render as-is (see getCfStatusLabel).
export const CF_STATUS_LABELS = {
  APPROVED: "CF Approved",
  EXCEPTION_PENDING: "Exception Pending",
};

// Returns the display label for a status/stage value, falling back to the
// raw value when there's no override.
export const getCfStatusLabel = (value) => CF_STATUS_LABELS[value] || value;

export const CF_FORM_CITY_OPTIONS_URL = `${process.env.PUBLIC_URL || ""}/cf-form-city-options.json`;

let cfFormCityOptionsCache = null;

// Loads the city options from the static JSON asset at runtime (not bundled).
// Result is cached so the file is fetched only once per session.
export const loadCfFormCityOptions = async () => {
  if (cfFormCityOptionsCache) {
    return cfFormCityOptionsCache;
  }
  const response = await fetch(CF_FORM_CITY_OPTIONS_URL);
  if (!response.ok) {
    throw new Error(`Failed to load city options: ${response.status}`);
  }
  const data = await response.json();
  cfFormCityOptionsCache = Array.isArray(data) ? data : [];
  return cfFormCityOptionsCache;
};